var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center",class:_vm.mobile && !_vm.alwaysHorizontal ? 'flex-column' : 'flex-row',style:({ gap: (_vm.gap + "px") })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }